import React from 'react';
import { Server } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-columns">
        <div className="footer-col footer-about">
          <div className="footer-brand">
            <Server className="footer-icon" />
            <span className="footer-title">HostWare</span>
          </div>
          <p className="footer-text">
            HostWare est une entreprise qui a pour objectif de fournir des services d'hébergement de qualité à prix réduit.<br />
            Nous sommes enregistrés sous le siret 94493628500013 et notre siège social est situé à Magny-les-Hameaux (78), France.
          </p>
          <a href="/a-propos" className="footer-btn">À propos de nous</a>
        </div>
        <div className="footer-col">
          <h3 className="footer-heading">Hébergement</h3>
          <ul className="footer-links">
            <li><a href="/novalife">Nova-Life</a></li>
            <li><a href="/minecraft">Minecraft</a></li>
            <li><a href="/fivem">FiveM</a></li>
            <li><a href="/gmod">Garry's mod</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h3 className="footer-heading">Juridique</h3>
          <ul className="footer-links">
            <li><a href="/mentions-legales">Mentions légales</a></li>
            <li><a href="https://cvg.hostware.fr">Conditions générales</a></li>
            <li><a href="/https://client.hostware.fr/client/support">Liens et contact</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2025 HostWare</span>
        <span>Toute copie, reproduction ou diffusion de ce site est interdite sans autorisation préalable</span>
      </div>
    </footer>
  );
};

export default Footer;
